import React, { useMemo } from 'react';
import { ArrowUpRight } from 'lucide-react';
import { cn } from '../../lib/utils';
import './plan-your-visit-orb.css';

/** ~19 glyphs fill the circle at 19deg each (Uiverse Creatlydev pattern). */
const RING_SLOTS = 19;

function buildRingChars(label: string): string[] {
  const cleaned = label.trim().toUpperCase();
  if (!cleaned) return Array.from({ length: RING_SLOTS }, () => '·');
  const withSep = `${cleaned} · `;
  let out = '';
  while (out.length < RING_SLOTS) out += withSep;
  return out.slice(0, RING_SLOTS).split('');
}

type PlanYourVisitOrbButtonProps = {
  label: string;
  onClick: () => void;
  className?: string;
  compact?: boolean;
};

/**
 * Circular rotating-text CTA (Uiverse Creatlydev) — opens calendar assistant.
 */
export const PlanYourVisitOrbButton: React.FC<PlanYourVisitOrbButtonProps> = ({
  label,
  onClick,
  className,
  compact = false,
}) => {
  const chars = useMemo(() => buildRingChars(label), [label]);

  return (
    <button
      type="button"
      className={cn('plan-visit-orb', compact && 'plan-visit-orb--compact', className)}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      aria-label={label}
    >
      <span className="plan-visit-orb__text" aria-hidden>
        {chars.map((ch, i) => (
          <span key={`${ch}-${i}`} style={{ ['--index' as string]: i }}>
            {ch === ' ' ? '\u00A0' : ch}
          </span>
        ))}
      </span>
      <span className="plan-visit-orb__circle" aria-hidden>
        <ArrowUpRight className="plan-visit-orb__icon" strokeWidth={2.25} />
        <ArrowUpRight
          className="plan-visit-orb__icon plan-visit-orb__icon--copy"
          strokeWidth={2.25}
        />
      </span>
    </button>
  );
};

export default PlanYourVisitOrbButton;
